<template>
  <v-container>
    <v-card cols="3" xs="6" sm="6" md="3" lg="3" xl="3" flat color="grey lighten-3" v-if="checked" class="mb-5">
      <v-card-text>
        <v-row>
          <v-col cols="6" v-for="(option, idx) in question.questionOptions" :key="idx">
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="6">
                    <v-text-field dense outlined label="Option Text" placeholder="Option Text"
                      v-model="option.optionContent[0].optionText" @blur="updateQuestion(question)" clearable>
                    </v-text-field>
                    <v-text-field dense outlined label="Option Help" placeholder="Option Help"
                      v-model="option.optionContent[0].optionHelp" @blur="updateQuestion(question)" clearable>
                    </v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-slider dense v-model="option.answerNumeric" @change.prevent="updateQuestion(question)" :max="10"
                      label="Answer Value" class="mt-0">
                      <template v-slot:append>
                        <v-text-field dense outlined v-model="option.answerNumeric" @blur="updateQuestion(question)"
                          type="number" style="width: 60px"></v-text-field>
                      </template>
                    </v-slider>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: "multiple",
    props: {
      question: Object,
      updateQuestion: Function,
    },

    data: () => ({
      checked: true,
    }),

    methods: {
      checkStructure() {
        let self = this;

        if (self.question.questionOptions.length != 1) {
          self.question.questionOptions = [];
          var newOption = {
            id: 0,
            questionnaireQuestionId: self.question.id,
            answerNumeric: 10,
            answerText: "",
            answerBool: false,
            optionContent: [{
              id: 0,
              languageId: 0,
              questionnaireQuestionOptionId: 0,
              optionText: "Rating",
              optionHelp: "",
            }, ],
          };
          self.question.questionOptions.push(newOption);
        }

        self.checked = true;
      },
    },
    mounted() {
      this.checkStructure();
    },
  };
</script>